export type SendOtpType = 'sms' | 'dob';
export const SendOtpType: Record<SendOtpType, SendOtpType> = {
  sms: 'sms',
  dob: 'dob',
} as const;

export type SendOtpResponse = {
  appId: string;
  last4NRIC: string;
  maskPhone: string;
  otpType: SendOtpType;
};
